import { createSlice } from '@reduxjs/toolkit'


export const alertSlice = createSlice({
    name: 'alerts',
    initialState: {
        header: '',
        body: ''
    },
    reducers: {
        clear: state => {state.header = ''; state.body = '';},
        setAlertBody: (state, action) => {
            state.body = action.payload
        },
        setAlertHeader: (state, action) => {
            state.header = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { clear, setAlertBody, setAlertHeader} = alertSlice.actions

export default alertSlice.reducer